__turbopack_context__.v({
  "root": "SubscriptionCTA-module__eTXSCq__root",
});
